import { render, staticRenderFns } from "./PriceSection.vue?vue&type=template&id=ea3a7922&"
import script from "./PriceSection.vue?vue&type=script&lang=js&"
export * from "./PriceSection.vue?vue&type=script&lang=js&"
import style0 from "./PriceSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports